import Cookie from './http/cookie';

export default class Http
{
	static Cookie = Cookie;
}